import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { STATUSES, statusLabel } from "@/lib/content";
import { Plus } from "lucide-react";

export default function Dashboard() {
  const [articles, setArticles] = useState([]);
  const [subscribers, setSubscribers] = useState([]);

  useEffect(() => {
    api.get("/admin/articles").then(({ data }) => setArticles(data)).catch(() => {});
    api.get("/admin/subscribers").then(({ data }) => setSubscribers(data)).catch(() => {});
  }, []);

  const byStatus = (s) => articles.filter((a) => a.status === s).length;
  const activeSubs = subscribers.filter((s) => s.status === "active").length;

  return (
    <div data-testid="admin-dashboard">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="font-serif text-3xl text-bz-navy">Tableau de bord</h1>
          <p className="mt-2 text-sm text-bz-slate">Vue d'ensemble de l'atelier éditorial.</p>
        </div>
        <Link to="/admin/articles/new" data-testid="dashboard-new-article" className="inline-flex items-center gap-2 bg-bz-navy px-5 py-3 text-xs uppercase tracking-[0.15em] text-bz-ivory transition-colors hover:bg-bz-petrol">
          <Plus size={16} strokeWidth={1.8} /> Nouveau décryptage
        </Link>
      </div>

      <div className="mt-10 grid grid-cols-2 gap-px overflow-hidden border border-bz-line bg-bz-line sm:grid-cols-3 lg:grid-cols-6">
        {STATUSES.map((s) => (
          <div key={s.slug} className="bg-white p-6" data-testid={`stat-${s.slug}`}>
            <p className="font-serif text-3xl text-bz-navy">{byStatus(s.slug)}</p>
            <p className="mt-1 text-xs uppercase tracking-[0.12em] text-bz-slate">{s.label}</p>
          </div>
        ))}
        <div className="bg-white p-6" data-testid="stat-subscribers">
          <p className="font-serif text-3xl text-bz-navy">{activeSubs}</p>
          <p className="mt-1 text-xs uppercase tracking-[0.12em] text-bz-slate">Abonnés actifs</p>
        </div>
      </div>

      <div className="mt-12">
        <div className="flex items-center justify-between">
          <h2 className="font-serif text-2xl text-bz-navy">Décryptages récents</h2>
          <Link to="/admin/articles" className="text-sm text-bz-petrol underline underline-offset-4">Tout voir</Link>
        </div>
        <ul className="mt-6 divide-y divide-bz-line border-y border-bz-line">
          {articles.slice(0, 5).map((a) => (
            <li key={a.id} className="flex items-center justify-between gap-4 py-4">
              <Link to={`/admin/articles/${a.id}/edit`} className="text-base text-bz-navy hover:text-bz-petrol">{a.title}</Link>
              <span className="shrink-0 text-xs uppercase tracking-[0.12em] text-bz-slate">{statusLabel(a.status)}</span>
            </li>
          ))}
          {articles.length === 0 && <li className="py-6 text-sm text-bz-slate">Aucun décryptage pour le moment.</li>}
        </ul>
      </div>
    </div>
  );
}
